module.exports = __webpack_public_path__ + "media/src/website/images/locations/muehldorf/muehldorf_04-356765f0105710115d119eedb25121a4.jpg";